import { SET_IS_NEW_RECORD } from '../actionTypes';
import { createTemplateModalActions } from '../reducer';

export default (value) => createTemplateModalActions[SET_IS_NEW_RECORD](value);
